import axios from 'axios';
import { put, call } from 'redux-saga/effects';

// CONSTANTS
import {
  WEBHOOKS_GET_DICTIONARY,
  WEBHOOKS_ADD_CUSTOMER_CREDITS,
  WEBHOOKS_UPDATE_CUSTOMER_CREDITS,
  WEBHOOKS_CANCEL_CUSTOMER_CREDITS,
} from '@/constants/api';

// UTILITY
import { showErrorNotification } from '@/utility/saga';
import { pushSuccessNotification } from '@/utility/snackbar';

import { t } from '@/locale/i18n';

// STORE
import { WebhooksActions } from '@/store/actions';

const { getWebhooksDictionary, addCustomerCredits, updateCustomerCredits, cancelCustomerCredits } =
  WebhooksActions;

export function* getWebhooksDictionarySaga() {
  yield put({ type: getWebhooksDictionary.types.START });

  try {
    const { data: respData } = yield axios.get(WEBHOOKS_GET_DICTIONARY);

    yield put({
      type: getWebhooksDictionary.types.SUCCESS,
      payload: {
        data: respData,
      },
    });

    return respData;
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: getWebhooksDictionary.types.FAIL,
    });

    return null;
  }
}

export function* addCustomerCreditsSaga(action) {
  yield put({ type: addCustomerCredits.types.START });

  const { data, onSuccess } = action.payload;

  try {
    yield axios.post(WEBHOOKS_ADD_CUSTOMER_CREDITS, {
      ...data,
      account_id: data.account_id || null,
    });

    pushSuccessNotification(t('notification.webhookSentSuccess'));

    if (onSuccess) onSuccess();

    yield put({
      type: addCustomerCredits.types.SUCCESS,
    });
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: addCustomerCredits.types.FAIL,
    });
  }
}

export function* updateCustomerCreditsSaga(action) {
  yield put({ type: updateCustomerCredits.types.START });

  const { data, onSuccess } = action.payload;

  try {
    yield axios.post(WEBHOOKS_UPDATE_CUSTOMER_CREDITS, {
      ...data,
      account_id: data.account_id || null,
    });

    pushSuccessNotification(t('notification.webhookSentSuccess'));

    if (onSuccess) onSuccess();

    yield put({
      type: updateCustomerCredits.types.SUCCESS,
    });
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: updateCustomerCredits.types.FAIL,
    });
  }
}

export function* cancelCustomerCreditsSaga(action) {
  yield put({ type: cancelCustomerCredits.types.START });

  const { data, onSuccess } = action.payload;

  try {
    yield axios.post(WEBHOOKS_CANCEL_CUSTOMER_CREDITS, {
      ...data,
      account_id: data.account_id || null,
    });

    pushSuccessNotification(t('notification.webhookSentSuccess'));

    if (onSuccess) onSuccess();

    yield put({
      type: cancelCustomerCredits.types.SUCCESS,
    });
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: cancelCustomerCredits.types.FAIL,
    });
  }
}

export default addCustomerCreditsSaga;
